import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Grid
} from '@material-ui/core';

const styles = () => ({
    displayFlex: {
        display: 'flex',
    },
    verticalSpace: {
        margin: '25px 0px 20px 50px',
    },
    clearButtonSpace: {
        margin: '25px 50px 20px 0px',
    },
});

const ResetButton = (props) => {
    const {
        classes,
        setTitle,
        setRequsetStartDate,
        setRequsetEndDate,
        setState,
        setSelectCategory,
        setDisplayCategory,
        setData,
        setPage,
        setDiaplayState,
        setFullTextDisplayFlg,
        setAddressNumber,
        setNickName
    } = props;

    const clearUserDatas = () => {
        setTitle('');
        setRequsetStartDate('');
        setRequsetEndDate('');
        setState('');
        setSelectCategory([]);
        setDisplayCategory([]);
        setData([]);
        setPage(1);
        setDiaplayState('');
        setAddressNumber('');
        setNickName('');
        setFullTextDisplayFlg(false);
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button size="large" className={classes.clearButtonSpace} variant="contained" onClick={() => clearUserDatas()}>リセット</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
};

ResetButton.propTypes = {
    classes: PropTypes.object.isRequired,
    setTitle: PropTypes.func.isRequired,
    setRequsetStartDate: PropTypes.func.isRequired,
    setRequsetEndDate: PropTypes.func.isRequired,
    setState: PropTypes.func.isRequired,
    setSelectCategory: PropTypes.func.isRequired,
    setDisplayCategory: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    setDiaplayState: PropTypes.func.isRequired,
    setAddressNumber: PropTypes.func.isRequired,
    setNickName: PropTypes.func.isRequired
};

export default withStyles(styles)(ResetButton);